import { IJsonQuery } from '@cian/api-models/common/json_query';

import { setLandArea } from './setLandArea';

export function setMaxLandArea(jsonQuery: IJsonQuery): (maxLandArea: number | undefined) => IJsonQuery {
  return (maxLandArea) => setLandArea(jsonQuery)(
    jsonQuery.site && jsonQuery.site.value.gte,
    maxLandArea,
  );
}
